export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// ./~/d3-queue/index.js
// module id = 1866
// module chunks = 1